/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Users_Invite_Not_SentInputs */

const cs_users_invite_not_sent = /** @type {(inputs: Users_Invite_Not_SentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pozvánku se nepodařilo odeslat (e-mail vypnut nebo chyba): ${i?.count}`)
};

const en_users_invite_not_sent = /** @type {(inputs: Users_Invite_Not_SentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Invitation not sent (e-mail disabled or failed): ${i?.count}`)
};

/**
* | output |
* | --- |
* | "Invitation not sent (e-mail disabled or failed): {count}" |
*
* @param {Users_Invite_Not_SentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const users_invite_not_sent = /** @type {((inputs: Users_Invite_Not_SentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Invite_Not_SentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_invite_not_sent(inputs)
	return cs_users_invite_not_sent(inputs)
});